import { render } from "./BoardCustomer.vue?vue&type=template&id=3da6b42e"
import script from "./BoardCustomer.vue?vue&type=script&lang=js"
export * from "./BoardCustomer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__